/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description Constants for the API
 * @section 4.5
 */
import axios, { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import * as config from "./../configuration/index";
import { TNavItem } from "./../configuration/types";
import { useAppContext } from "./../context/AppCtxProvider";
import useCurrentUser from "./../context/UserContext";
export interface Data {
  _id: string;
  title: string;
  enabled: boolean;
  description?: string;
  group?: string | null;
  link: string;
  icon?: string | JSX.Element;
  sideBarIcon?: string | JSX.Element;
  children: Data[];
  rangecolor?: string;
  customValue1?: string; //  JS_ATTR
}
const useNavitems = (path?: string[]) => {
  const user = useCurrentUser();
  const ctx = useAppContext();
  const navItemsList = useQuery<TNavItem>(
    `navitems-${user.profileId}-${ctx.modelId}`,
    async () => {
      const response = await axios.get<AxiosResponse<TNavItem>>(
        `${process.env.REACT_APP_SERVER_URL}/navitems`
      );
      return config.System.mapNavitems(response.data.data);
    }
  );
  return navItemsList;
};
export default useNavitems;
